import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import { oliveLogo } from '../constants/icons';
import ErrorDescription from '../components/ErrorDescription';

function Error404({ className }) {
  return (
    <div className={`${className || ''} error-wrapper px-3`}>
      <Row className="row justify-content-between align-items-center text-center min-vh-100">
        <Col lg={12} className="mb-4">
          {/* <a href="#" className="logo-brand">
            {oliveLogo}
          </a> */}
        </Col>
        <Col lg={12} className="mb-4">
          <ErrorDescription error404Title="404." error404Info="We couldn't find that page." />
        </Col>
        <Col lg={12} className="mb-4">
          <p className="mb-0">The page you are looking for does not exist or other error occured.</p>
          {/* <p className="mb-0">
            <a href="#">Go back</a>, or head over to <a href="https://olive.io">olive.io</a> to choose a new direction
          </p> */}
        </Col>
      </Row>
    </div>
  );
}

export default Error404;
